import { defineStore } from 'pinia'

export const useAppStockStore = defineStore('appStock', {
    state: () => ({
        stock_mode:0,
    }),
    actions: {
        reset_data() {
            this.stock_mode = 0;
        },
    },
    persist: true,
})
